import React from 'react'

import Slider1 from '../../static/images/slider/slider1.jpg'
import Slider2 from '../../static/images/slider/slider2.jpg'
import Slider3 from '../../static/images/slider/slider3.jpg'
import Slider4 from '../../static/images/slider/slider4.jpg'
import Slider5 from '../../static/images/slider/slider5.jpg'

import Industry from '../../static/images/icons/industry.svg'
import Rocket from '../../static/images/icons/slider/rocket.svg'
import Team from '../../static/images/icons/slider/team.svg'
import Spread from '../../static/images/icons/slider/spread.svg'
import India from '../../static/images/icons/slider/india.svg'
import Chart from '../../static/images/icons/slider/chart.svg'

const Slider = () => {
  return (
    <div className='section slider'>
      <div
        id='carouselExampleCaptions'
        className='carousel slide carousel-fade'
        data-bs-ride='carousel'
        data-aos='fade-up'
        data-aos-delay='300'
        data-interval='10000'
      >
        <div className='carousel-indicators'>
          <button
            type='button'
            data-bs-target='#carouselExampleCaptions'
            data-bs-slide-to='0'
            className='active'
            aria-current='true'
            aria-label='Slide 1'
          ></button>
          <button
            type='button'
            data-bs-target='#carouselExampleCaptions'
            data-bs-slide-to='1'
            aria-label='Slide 2'
          ></button>
          <button
            type='button'
            data-bs-target='#carouselExampleCaptions'
            data-bs-slide-to='2'
            aria-label='Slide 3'
          ></button>

          <button
            type='button'
            data-bs-target='#carouselExampleCaptions'
            data-bs-slide-to='3'
            aria-label='Slide 4'
          ></button>

          <button
            type='button'
            data-bs-target='#carouselExampleCaptions'
            data-bs-slide-to='4'
            aria-label='Slide 5'
          ></button>
        </div>
        <div className='carousel-inner'>
          <div className='carousel-item active'>
            <img src={Slider1} className='d-block w-100' alt='...' />
            <div className='carousel-caption d-md-block'>
              <img src={Industry} />
              <h1>We The Rean</h1>
              <p>
                Rean is a Bootstrapped, Fast Growing, Pure play, Uniquely
                Positioned and only Triple Bottom Line ethos Water Company of
                India
              </p>
            </div>
          </div>
          <div className='carousel-item'>
            <img src={Slider2} className='d-block w-100' alt='...' />
            <div className='carousel-caption d-md-block'>
              <img src={Rocket} />
              <h1>Growth Beast</h1>
              <p>
                Rean is the most successful and fast growing Water Company,
                giving highest returns to stakehlders
              </p>
            </div>
          </div>
          <div className='carousel-item'>
            <img src={Slider3} className='d-block w-100' alt='...' />
            <div className='carousel-caption d-md-block'>
              <img src={Team} />
              <h1>Wizards onboard</h1>
              <p>
                Rean is founded by passionate technocrats and supported by
                sensibly aggresive young techno-commercial team with >80%
                engineers
              </p>
            </div>
          </div>

          <div className='carousel-item'>
            <img src={Slider4} className='d-block w-100' alt='...' />
            <div className='carousel-caption d-md-block'>
              <img src={Spread} />
              <h1>Mapping Horizons</h1>
              <p>
                Rean is expanding rapidly geographycally while the team is
                getting bigger and better simultaneously
              </p>
            </div>
          </div>

          <div className='carousel-item'>
            <img src={Slider5} className='d-block w-100' alt='...' />
            <div className='carousel-caption d-md-block'>
              <img src={Chart} />
              <h1>Revenue Machine</h1>
              <p>
                Rean grew from 0 to 100 cr revenue (4 fiscal) with highest
                EBIDTA and minimal debt in Segment
              </p>
            </div>
          </div>
        </div>
        <button
          class='carousel-control-prev'
          type='button'
          data-bs-target='#carouselExampleCaptions'
          data-bs-slide='prev'
        >
          <span class='carousel-control-prev-icon' aria-hidden='true'></span>
          <span class='visually-hidden'>Previous</span>
        </button>
        <button
          class='carousel-control-next'
          type='button'
          data-bs-target='#carouselExampleCaptions'
          data-bs-slide='next'
        >
          <span class='carousel-control-next-icon' aria-hidden='true'></span>
          <span class='visually-hidden'>Next</span>
        </button>
      </div>
    </div>
  )
}

export default Slider
